import React, { useRef } from "react";

// React wrapper for Om Design System Header web component
const OmHeader = React.forwardRef(({ 
  header,
  subHeader,
  actionButtonText,
  type = "large-page-header",
  onActionButtonClick,
  ...props 
}, ref) => {
  const elementRef = useRef(null);

  const handleActionButtonClick = (event) => {
    if (onActionButtonClick) {
      onActionButtonClick(event);
    }
  };

  return (
    <omk-header
      ref={(el) => {
        elementRef.current = el;
        if (ref) {
          if (typeof ref === 'function') {
            ref(el);
          } else {
            ref.current = el;
          }
        }
      }}
      header={header}
      sub-header={subHeader}
      action-button-text={actionButtonText}
      type={type}
      onActionButtonClickCompleted={handleActionButtonClick}
      {...props}
    />
  );
});

OmHeader.displayName = 'OmHeader';

export default OmHeader;
